import type { FetchCustomersListQuery } from '@/features/customers/api'
import type { CustomersSearch } from '@/routes/_protected/$tenantKey/settings/customers/-models'

export function buildFetchCustomersQuery(
  tenantKey: string,
  deps: CustomersSearch
): FetchCustomersListQuery {
  return {
    tenantKey,
    query: {
      ...deps,
      ...(deps.dcId !== undefined ? { dcIds: [deps.dcId] } : {}),
      orders: ['code.asc']
    }
  }
}
